import type { InjectionKey } from 'vue';

import type { GetOrderResponseDto, ValueAddedServiceDto } from '~/apiClient';

export const INJECTION_KEYS = {
    ORDER_DATA: Symbol('ORDER_DATA') as InjectionKey<Ref<GetOrderResponseDto | undefined>>,
    VALUE_ADDED_SERVICES: Symbol('VALUE_ADDED_SERVICES') as InjectionKey<Ref<ValueAddedServiceDto[] | undefined>>,
} as const;
